import {
  CitySelectionWidget,
  StateSelectionWidget,
} from "components/FormWidget";

const uiSchema = () => ({
  city_id: {
    "ui:widget": CitySelectionWidget,
  },
  state_id: {
    "ui:widget": StateSelectionWidget,
  },
});

export default uiSchema;
